import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./style.css";
import { store } from "./store";
import App from "./App";
import { setup3DScene } from "./3d";

const domContainer = document.querySelector("#ui");
const root = ReactDOM.createRoot(domContainer);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// setup3DScene();
